import {useEffect} from 'react';
import {setEmailMakerIsSharedInTeam} from '@EmailMakerReact/reducers/email-maker-publish-state-reducer';
import type {EmailMakerImmutableStore} from '@EmailMakerReact/email-maker-react.types';

/**
 * Seeds the mutable `emailMakerPublishState` Redux slice from the immutable store payload on
 * mount. After seeding, the share-button reads from the mutable slice so the icon can toggle
 * live when the share-in-team popup posts a state update — without a page reload.
 *
 * Called once at the root of the email-maker React tree (see `EmailMakerReact`).
 */
export function useEmailMakerPublishStateInit(store: EmailMakerImmutableStore): void {
  useEffect(() => {
    window.PMW.redux.store.dispatch(setEmailMakerIsSharedInTeam(store.isSharedInTeam));
  }, [store.isSharedInTeam]);
}
